import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule } from '@angular/common/http';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './services/auth/token.interceptor';
import { IonicStorageModule } from '@ionic/storage';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { NavService } from './services/nav/nav.service';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { LoginLayoutPageModule } from './layout/login-layout/login-layout.module';
import { MainLayoutPageModule } from './layout/main-layout/main-layout.module';
import { MenuPageModule } from './components/menu/menu.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { NgxSpinnerModule } from 'ngx-spinner';

import { DialogPage } from './members/dashboard/dashboard.page';
import { DialogSecondPage } from './members/reload/reload.page';
import { DialogThirdPage } from './members/payment/payment.page';
import { DialogIPRPage } from './members/ipr-payment/ipr-payment.page';
import { DialogEightPage } from './members/password/password.page';
import { DialogProfilePage } from './members/profile/profile.page';
import { DialogNwReturnDoCreatePage } from './members/nw-return-do-create/nw-return-do-create.page';
import { DialogNinePage } from './members/inreload/inreload.page';
import { DialogTenPage } from './members/posm-customer-add/posm-customer-add.page';
import { DialogElevenPage } from './members/posm-customer-search/posm-customer-search.page';
import { DialogTwelvePage } from './members/posm-pl9-create/posm-pl9-create.page';
import { DialogThirteenPage } from './members/posm-pl9-search/posm-pl9-search.page';
import { DialogFourteenPage } from './members/posm-search/posm-search.page';
import { DialogPosmPage } from './members/posm/posm.page';
import { DialogNwPage } from './members/nw/nw.page';
import { DialogPOSBuyPage } from './members/posm-merchandise-pdet/posm-merchandise-pdet.page';
import { DialogPOSDropPage } from './members/posm-merchandise-ddet/posm-merchandise-ddet.page';
import { DialogErrorLoginPage } from './services/auth/auth.service';
import { DialogChangePasswordPage } from './members/password/password.page';
import { DialogNullNewandVerifyPasswordPage } from './members/password/password.page';
import { DialogNullNewandVerifyPasswordCharactersLimitPage } from './members/password/password.page';
import { DialogBangladeshPage } from './members/bangladesh/bangladesh.page';
import { DialogNepalPage } from './members/nepal/nepal.page';
import { DialogLazadaPage } from './members/lazada/lazada.page';
import { DialogShopeePage } from './members/shopee/shopee.page';
import { DialogTNGPage } from './members/touchngo/touchngo.page';
import { DialogApplyDigitalidPage } from './members/apply-digitalid/apply-digitalid.page';
import { DialogCheckStatusDigitalidPage } from './members/check-status-digitalid/check-status-digitalid.page';
import { DialogCheckStatusLoanPage } from './members/check-status-loan/check-status-loan.page';


import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MatCardModule,
  MatFormFieldModule,
  MatProgressSpinnerModule,
  MatInputModule,
  MatButtonModule,
  MatIconModule,
  MatRadioModule,
  MatListModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
  MatSelectModule,
  MatTabsModule
} from '@angular/material';

import { MatMomentDateModule} from '@angular/material-moment-adapter';

library.add(fas, far, fab);

@NgModule({
  declarations: [AppComponent, DialogIPRPage, DialogErrorLoginPage, DialogPage, DialogSecondPage, DialogThirdPage, DialogEightPage, DialogProfilePage, DialogNwReturnDoCreatePage, DialogNinePage, DialogTenPage, DialogElevenPage, DialogTwelvePage, DialogThirteenPage, DialogFourteenPage, DialogPosmPage, DialogPOSDropPage, DialogPOSBuyPage, DialogNwPage, DialogChangePasswordPage, DialogNullNewandVerifyPasswordPage, DialogNullNewandVerifyPasswordCharactersLimitPage, DialogBangladeshPage, DialogNepalPage,DialogLazadaPage, DialogShopeePage, DialogTNGPage, DialogCheckStatusDigitalidPage, DialogApplyDigitalidPage, DialogCheckStatusLoanPage],
  entryComponents: [DialogIPRPage, DialogErrorLoginPage, DialogPage, DialogSecondPage, DialogThirdPage, DialogEightPage,DialogProfilePage, DialogNwReturnDoCreatePage, DialogNinePage, DialogTenPage, DialogElevenPage, DialogTwelvePage, DialogThirteenPage, DialogFourteenPage, DialogPosmPage, DialogPOSDropPage, DialogPOSBuyPage, DialogNwPage, DialogChangePasswordPage, DialogNullNewandVerifyPasswordPage, DialogNullNewandVerifyPasswordCharactersLimitPage, DialogBangladeshPage, DialogNepalPage,DialogLazadaPage, DialogShopeePage, DialogTNGPage,DialogCheckStatusDigitalidPage, DialogApplyDigitalidPage, DialogCheckStatusLoanPage],
  imports: [
    BrowserModule,
    HttpClientModule,
    MatCardModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatListModule,
    MatDatepickerModule,
    LoginLayoutPageModule,
    MainLayoutPageModule,
    FlexLayoutModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatSelectModule,
    MatDialogModule,
    MatTabsModule,
    MenuPageModule,
    NgxSpinnerModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    IonicStorageModule.forRoot()
  ],
  providers: [
    NavService,
    StatusBar,
    BarcodeScanner,
    SplashScreen,
    InAppBrowser,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
